import { testimonials } from "@/mocks/categories";

export default function Testimonials() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-label tracking-wider uppercase text-foreground-500">
              Verified Reviews
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
            Trusted by
            <br className="md:hidden" /> Shoppers Worldwide
          </h2>
          <p className="text-sm text-foreground-500 font-label mt-2">
            Real feedback from our community of smart shoppers
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-0.5 mb-3">
                {[...Array(5)].map((_, s) => (
                  <i key={s} className="ri-star-fill text-accent-400 text-sm"></i>
                ))}
              </div>
              <h3 className="text-sm md:text-base font-label font-semibold text-foreground-950 mb-2">
                {t.title}
              </h3>
              <p className={`text-xs md:text-sm text-foreground-500 leading-relaxed flex-1 mb-4 ${
                i === 5 ? "line-clamp-4" : ""
              }`}>
                {t.body}
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-label font-semibold text-primary-700">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-xs font-label font-semibold text-foreground-950">
                    {t.name}
                  </p>
                  <p className="text-xs text-foreground-400 font-label">
                    {t.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}